import React from 'react';
import { PRODUCT, SUPPORT_EMAIL } from '../data/constants';
export function Footer() {
  return <footer className="border-t-4 border-teal bg-navy py-4" data-id="element-60" data-mp="3gfsjo3v2keir">
      <div className="mx-auto max-w-5xl px-4 sm:px-6" data-id="element-61" data-mp="3gh3qkcjta2e3">
        <p className="text-xs font-semibold leading-snug text-white/85 sm:text-sm" data-id="element-62" data-mp="32ovz90bar3ms">
          © 2026 {PRODUCT} — All Rights Reserved.
        </p>
        <p className="mt-1 text-xs leading-snug text-white/70 sm:text-sm" data-id="element-63" data-mp="36n3c3k2n3ksp">
          {PRODUCT} is an independent educational and professional reference resource. It does not
          provide nursing licensure, professional certification, clinical competency validation,
          or authorization to perform medical procedures. It does not replace supervised clinical
          training, professional judgment, current evidence-based guidelines, medication
          references, or institutional protocols. All clinical procedures and patient care
          decisions must be performed by appropriately qualified professionals within their
          authorized scope of practice.
        </p>
        <p className="mt-1.5 text-xs font-semibold uppercase tracking-wide text-white/70 sm:text-sm" data-id="element-64" data-mp="3lbmvrwv0jgi0">
          Terms &amp; Conditions • Privacy Policy • Contact
        </p>
        <p className="mt-1 text-xs text-white/70 sm:text-sm" data-id="element-65" data-mp="3v9azhcaljycb">
          Support:{' '}
          <a href={`mailto:${SUPPORT_EMAIL}`} className="text-white underline decoration-tech underline-offset-2 transition-colors duration-150 ease-out hover:text-tech-light" data-id="element-66" data-mp="3q7u23qrbmu0h">
            {SUPPORT_EMAIL}
          </a>
        </p>
      </div>
    </footer>;
}